import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import './plugins/element.js'
import '@/assets/best.css'
import '@/assets/index.scss'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'g5zsPBGPMi57eF6uwYjOWUlUrBtCPOwi'
})
Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
